import { Component } from 'react';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-additional-view-btn-groups">
                        <button
                            className={`${(!this.props.view || this.props.view === 1) && 'active'}`}
                            onClick={() => this.props.chooseView(1)}
                        >
                            {t('discover.categories.table.nested_view')}
                        </button>
                        <button
                            className={`${this.props.view === 2 && 'active'}`}
                            onClick={() => this.props.chooseView(2)}
                        >
                            {t('discover.categories.table.2nd_level')}
                        </button>
                        <button
                            className={`${this.props.view === 3 && 'active'}`}
                            onClick={() => this.props.chooseView(3)}
                        >
                            {t('discover.categories.table.3rd_level')}
                        </button>
                    </div>
                    {this.props.hasTree && (
                        <button
                            type="button"
                            className="table-additional-view-btn"
                            onClick={() => {
                                // check if "all categories" is open or not
                                if (!this.props.tree.state.ids.includes('all_categories')) {
                                    this.props.tree.fns.onToggleById('all_categories');
                                }

                                // minus 1 because ids doesn't include 'all_categoris'
                                // this one for closing all
                                if (
                                    this.props.tree.state.ids.length - 1 ===
                                    this.props.ids.current?.length
                                ) {
                                    return this.props.ids.current.forEach((id) =>
                                        this.props.tree.fns.onToggleById(id),
                                    );
                                }

                                //this one for opening all
                                this.props.ids.current?.forEach((id) => {
                                    if (!this.props.tree.state.ids.includes(id)) {
                                        this.props.tree.fns.onToggleById(id);
                                    }
                                });
                            }}
                        >
                            {this.props.tree.state.ids.length - 1 === this.props.ids.current?.length
                                ? t('discover.categories.table.collaps_all')
                                : t('discover.categories.table.expand_all')}
                        </button>
                    )}
                </div>
                <div className="toggle-Invalid-items">
                    <span
                        className={`switch-button  without-text mr-10 ${
                            this.props.isConfidence ? 'active' : 'not-active'
                        }`}
                        onClick={this.props.toggle}
                        title="Delayed"
                    >
                        <span className="switch-circle" />
                    </span>
                    <span> {t('discover.categories.table.relevancy_message')}</span>
                </div>
            </div>
        );
    }
}

export default AdditionalBox;
